const trimExtension = (string) => string.replace(/\.[^/.]+$/, "");

const icons = {};
const iconImports = require.context('./img', true, /\.(png)$/);

iconImports.keys().map(item => {
  const itemArray = item.split('/');
  const iconColorSize = `${itemArray[2]}-${trimExtension(itemArray[3])}`;

  icons[itemArray[1]] = {
    ...icons[itemArray[1]],
    [iconColorSize]: iconImports(item),
  };

  return item;
});

Object.defineProperty(icons, 'toArray', {
  get() {
    return () => Object.keys(this).map(key => {
      return { key, value: this[key] };
    });
  },
  configurable: true,
  enumerable: false,
});

export default icons;



// WEBPACK FOOTER //
// ./src/img/services/index.js